export const environment = {
  production: true,
  URL_API: 'https://apigwp.bciseguros.cl:8443/Apiventaasistidazenit',
  // https://apigwp.bciseguros.cl:8443/Apiventaasistidazenit QA
  // https://apigwp.bciseguros.cl:8443/Apiventaasistidazenit PROD
  cryptoKey: '%D*F-JaNdRgUkXp2s5v8y/B?E(H+KbPe',
  cnDefault: 'eGhZcTZUbkNBVHlweThneWNRR1VNQT09',
  IdApp: 46,
  RutEmpresa: 50000000,
  recaptchaActions: {
    Step1: 'datos_generales_inicio',
    Step2: 'datos_generales_cotizacion',
    Step3: 'datos_generales_datos_contratante',
  },
  recaptchaLabels: {
    ErrorTitle: 'Error de verificación',
    ErrorSubtitle: 'Posible actividad sospechosa detectada',
  },
};
